import { render, staticRenderFns } from "./certificateComponent.vue?vue&type=template&id=4faef104"
import script from "./certificateComponent.vue?vue&type=script&lang=js"
export * from "./certificateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports